import { useCallback } from "react";

import { useServicesContext } from "../../providers/ServicesProvider";
import { useUpdateSync } from "../useUpdateSync/useUpdateSync";
import { EVENT_TYPES } from "../../constants/constants";

/**
 * Wraps the bulk users CSV upload service call so components stay within the
 * UI → hooks → services → repositories layering (CLAUDE.md). Components consume
 * this hook rather than reaching into the services context directly.
 *
 * A successful upload creates a row in the Uploads tab's list, so this fires
 * `ADD_BULK_UPLOAD` for the `UpdateSynchronizer` to drop that list's cached pages.
 */
export const useBulkUpload = ({ organizationId }: { organizationId: string }) => {
    const { userService } = useServicesContext();
    const { fireChangeEvent } = useUpdateSync();

    const uploadUsersCsv = useCallback(
        async ({ file, userGroupIds }: { file: File; userGroupIds?: string[] }): Promise<void> => {
            await userService.uploadUsersCsv({ organizationId, file, userGroupIds });

            fireChangeEvent({ type: EVENT_TYPES.ADD_BULK_UPLOAD, data: {} });
        },
        [userService, organizationId, fireChangeEvent]
    );

    return { uploadUsersCsv };
};
